<template>
  <component-wrapper class="podcasts-fi">
    <podcasts-tabs-fi />
  </component-wrapper>
</template>

<script setup lang="ts">
import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import PodcastsTabsFi from '@/components/podcasts/podcasts-tabs-fi/PodcastsTabsFi.vue';

defineOptions({ name: 'PodcastsFi' });
</script>

<style scoped src="./podcasts-fi" />
